import { criticalAccountQueries, preloadCriticalQueries } from '@/queries/preloadCriticalQueries'
import { queryClient } from '@/queries/queryClient'
import router from '@/router'
import { useAuthStore } from '@/stores/auth'
import { computed, ref } from 'vue'

export const useAppReady = () => {
  const authStore = useAuthStore()
  const isRouteReady = ref(false)

  router.isReady().then(() => {
    isRouteReady.value = true
  })

  const isProtectedRoute = computed(() => router.currentRoute.value.meta.unauthenticated !== true)
  const shouldLoadBlockingQueries = computed(
    () => isRouteReady.value && authStore.isAuthenticated && isProtectedRoute.value,
  )
  const blockingQueries = criticalAccountQueries.blocking.map((query) => query.use(shouldLoadBlockingQueries))

  const isLoadingBlockingData = computed(() =>
    blockingQueries.some((query) => query.isFetching.value && query.data.value === undefined),
  )
  const error = computed(() => {
    const hasError = blockingQueries.some((query) => query.error.value)
    return shouldLoadBlockingQueries.value && hasError ? 'Something went wrong' : null
  })
  const isLoading = computed(() => !isRouteReady.value || isLoadingBlockingData.value)
  const isReady = computed(() => !isLoading.value && !error.value)

  const retry = () => {
    void preloadCriticalQueries(queryClient)
  }

  return {
    error,
    isLoading,
    isReady,
    retry,
  }
}
